import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromRoot from '../../../../app/state/app.selectors';
import * as fromCompany from './company.reducers';

export interface CompanyState {
  stateData: fromCompany.State;
}

export interface State extends fromRoot.AppState {
  company: CompanyState;
}

export const reducers = {
  stateData: fromCompany.reducer
};

export const selectCompanyState = createFeatureSelector<CompanyState>('company');

export const selectCompanyStateData = createSelector(selectCompanyState, (state: CompanyState) => state.stateData);

export const getCompanyState = createSelector(selectCompanyStateData, fromCompany.getStateData);

export const getCompanyScreenError = createSelector(selectCompanyStateData, fromCompany.getError);

export const getCompanyScreenPending = createSelector(selectCompanyStateData, fromCompany.getPending);